import { useMutation, useQuery } from "@tanstack/react-query";
import {
  RoleItem,
  RolePayload,
  SearchRolePayload,
} from "@/domain/role.interface";
import { RolesService } from "@/services/roles.service";

export const useSearchRoles = (
  { sortField, sortOrder, pageNumber, pageSize, search }: SearchRolePayload = {
    sortField: "name",
    sortOrder: 1,
    pageNumber: 0,
    pageSize: 100,
    search: "",
  },
) => {
  const {
    data: rolesResponse,
    isLoading: isLoadingRoles,
    isFetching: isFetchingRoles,
    refetch: refetchRoles,
  } = useQuery({
    queryKey: ["roles", sortField, sortOrder, pageNumber, pageSize, search],
    queryFn: () =>
      RolesService.search({
        sortField,
        sortOrder,
        pageNumber,
        pageSize,
        search,
      }),
  });

  return {
    rolesResponse,
    isLoadingRoles,
    isFetchingRoles,
    refetchRoles,
  };
};

export const useCreateRole = () => {
  return useMutation({
    mutationFn: (data: RolePayload) => RolesService.create(data),
  });
};

export const useUpdateRole = () => {
  return useMutation({
    mutationFn: (payload: { id: string; data: RolePayload }) =>
      RolesService.update({
        id: payload.id,
        data: payload.data,
      }),
  });
};

export const useDeleteRole = () => {
  return useMutation({
    mutationFn: (id: string) => RolesService.softDelete(id),
  });
};
